<img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png" alt=""/>

<mat-card class="simple-card mx-auto mb-5">
    <mat-card-content>
        <div class="row">

            <div class="col-12 d-flex justify-content-between">
                <h1>Licitación</h1>
                <button mat-flat-button 
                    class="custom-button-primary no-print"
                    [printTitle]='"Licitacion_"+codigoLicitacion'
                    [useExistingCss]="true"
                    printSectionId="print-section"
                    ngxPrint
                    >
                    <mat-icon 
                        aria-hidden="false" 
                        aria-label="Icono de descarga" 
                        fontIcon="get_app" 
                        class="icon-download mr-3"
                    ></mat-icon>
                    Descargar Resultado
                </button>
            </div>

            <div class="col-12 my-3" *ngIf="codigoLicitacion">
                <mat-chip-set aria-label="Codigo Licitación">
                    <mat-chip class="chip-rut"><strong>Código:</strong> {{codigoLicitacion || ''}}</mat-chip>
                </mat-chip-set>
            </div>

            <div class="col-12 mb-3">
                <div class="table-responsive p-2" *ngIf="dataLicitacion && objectKeys(dataLicitacion).length > 0">
                    <ng-container *ngTemplateOutlet="objTemplate; context: { $implicit: {obj: dataLicitacion} }"></ng-container>
                </div>
            </div>

        </div>
    </mat-card-content>
</mat-card>

<ng-template #objTemplate let-elemento>

    <table mat-table [dataSource]="objectKeys(elemento.obj)" class="border">

        <ng-container matColumnDef="label">
            <td mat-cell *matCellDef="let element" class="font-weight-bold"> {{element}} </td>
        </ng-container>

        <ng-container matColumnDef="value">
            <td mat-cell *matCellDef="let element"> 
                <ng-container *ngIf="esObjeto(elemento.obj[element])">
                    <div class="table-responsive p-2">
                        <ng-container *ngTemplateOutlet="objTemplate; context: { $implicit: {obj: elemento.obj[element]} }"></ng-container>
                    </div>
                </ng-container>
                <ng-container *ngIf="esArray(elemento.obj[element])">
                    <ng-container *ngFor="let item of elemento.obj[element]">
                        <ng-container *ngIf="esObjeto(item); else noObjeto">
                            <div class="table-responsive p-2">
                                <ng-container *ngTemplateOutlet="objTemplate; context: { $implicit: {obj: item} }"></ng-container>
                            </div>
                        </ng-container>
                        <ng-template #noObjeto>
                            {{item}}
                        </ng-template>
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="!esArray(elemento.obj[element]) && !esObjeto(elemento.obj[element])">
                    {{elemento.obj[element]}} 
                </ng-container>
            </td>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: ['label', 'value'];"></tr>
    </table>
    
</ng-template>
